import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { imageUrl, formatFCFA } from "../../lib/format";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { X, Plus, Link2 } from "lucide-react";

export const LinkedPicker = ({ selfId, value, onChange }) => {
  const [linked, setLinked] = useState([]);
  const [search, setSearch] = useState("");
  const [results, setResults] = useState([]);

  useEffect(() => {
    if (!value.length) { setLinked([]); return; }
    api.get("/admin/products", { params: { ids: value.join(","), limit: 50 } }).then((r) => setLinked(r.data.items));
  }, [value]);

  useEffect(() => {
    if (!search.trim()) { setResults([]); return undefined; }
    const t = setTimeout(() => {
      api.get("/admin/products", { params: { search, limit: 8 } }).then((r) => setResults(r.data.items));
    }, 300);
    return () => clearTimeout(t);
  }, [search]);

  const add = (id) => { onChange([...value, id]); setSearch(""); };
  const remove = (id) => onChange(value.filter((x) => x !== id));
  const candidates = results.filter((p) => p.id !== selfId && !value.includes(p.id));

  return (
    <div className="min-w-0 rounded-lg bg-[#F6E4DE] p-4" data-testid="linked-picker">
      <Label className="flex items-center gap-2 text-sm font-semibold text-[#2C1A14]"><Link2 className="h-4 w-4" /> Pièces coordonnées</Label>
      <p className="mt-1 text-xs text-[#9B7E73]">Les pièces reliées s'affichent dans « Complétez le look ». Le lien s'applique automatiquement dans les deux sens.</p>
      <div className="mt-3 flex flex-wrap gap-2">
        {linked.map((p) => (
          <div key={p.id} data-testid={`linked-item-${p.id}`} className="flex items-center gap-2 rounded-full bg-white py-1 pl-1 pr-2 ring-1 ring-[#E8D5CE]">
            <img src={imageUrl(p.images?.[0])} alt="" className="h-8 w-8 rounded-full object-cover" />
            <span className="max-w-[140px] truncate text-xs font-medium text-[#2C1A14]">{p.nom}</span>
            <button type="button" onClick={() => remove(p.id)} data-testid={`linked-remove-${p.id}`} className="rounded-full p-0.5 text-[#9B7E73] hover:bg-[#F6E4DE] hover:text-red-500"><X className="h-3.5 w-3.5" /></button>
          </div>
        ))}
        {!linked.length && <span className="text-xs italic text-[#9B7E73]">Aucune pièce reliée</span>}
      </div>
      <Input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Rechercher une pièce à relier…" data-testid="linked-search" className="mt-3 bg-white" />
      {candidates.length > 0 && (
        <div className="mt-2 max-h-56 overflow-y-auto rounded-md bg-white ring-1 ring-[#E8D5CE]">
          {candidates.map((p) => (
            <button type="button" key={p.id} onClick={() => add(p.id)} data-testid={`linked-add-${p.id}`} className="flex w-full min-w-0 items-center gap-3 px-3 py-2 text-left hover:bg-[#FBF1EE]">
              <img src={imageUrl(p.images?.[0])} alt="" className="h-10 w-8 rounded object-cover" />
              <span className="min-w-0 flex-1 truncate text-sm text-[#2C1A14]">{p.nom}</span>
              <span className="text-xs text-[#D76E4D]">{formatFCFA(p.prix)}</span>
              <Plus className="h-4 w-4 text-[#D76E4D]" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
